interface PresentIconProps {
  width?: string;
  height?: string;
  color?: string;
}

const PresentIcon = ({ width = "17", height = "18", color = "#002035" }: PresentIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 18"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7368 16.6481C14.7411 16.8265 14.5314 16.9735 14.2682 16.9766H2.91446C2.65126 16.9735 2.44155 16.8265 2.44587 16.6481V8.9762C2.44155 8.79784 2.65126 8.65081 2.91446 8.64771H14.2682C14.5314 8.65081 14.7411 8.79784 14.7368 8.9762V16.6481Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.183 8.51076C16.1883 8.58508 15.9293 8.64634 15.6042 8.64763H1.57893C1.2538 8.64634 0.994751 8.58508 1.00008 8.51076V5.31412C0.994751 5.2398 1.2538 5.17854 1.57893 5.17725H15.6042C15.9293 5.17854 16.1883 5.2398 16.183 5.31412V8.51076Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M8.59131 5.52417V16.6294" stroke={color} strokeWidth="1.5" strokeLinecap="square" />
      <path
        d="M12.4187 4.45165C13.9439 3.74046 14.9519 2.67427 14.6703 2.07024C14.3886 1.46621 12.9239 1.55308 11.3987 2.26428C9.87359 2.97547 8.86554 4.04166 9.1472 4.64569C9.42887 5.24972 10.8936 5.16285 12.4187 4.45165Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M4.89181 4.45165C3.36666 3.74046 2.35861 2.67427 2.64027 2.07024C2.92193 1.46621 4.38665 1.55308 5.9118 2.26428C7.43696 2.97547 8.44501 4.04166 8.16334 4.64569C7.88168 5.24972 6.41697 5.16285 4.89181 4.45165Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default PresentIcon;
